/*
  Start Color Pallate Code
*/

const bodyLoader = document.querySelectorAll(".loading-overlay");
const selectBodyWrapper = document.querySelector(".body");

if (bodyLoader.length) {
  const selectBodyWrapper = document.querySelector("body");
  if (selectBodyWrapper.classList.contains("loading-overlay-showing")) {
    setTimeout(() => {
      selectBodyWrapper.classList.remove("loading-overlay-showing");
    }, 3000);
  }
}

function getCookie(gname) {
  const formCookise = [];
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split("; ");
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === "") {
      c = c.substring(0);
    }

    if (c.indexOf(gname) === 0) {
      formCookise[i] = c;
    }
  }
  return formCookise;
}

function Setcookie(cname, cval) {
  const days = 30;
  const myDate = new Date();
  myDate.setTime(myDate.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie =
    cname +
    "=" +
    encodeURIComponent(cval).concat(";expires=").concat(myDate.toGMTString()) +
    ";path=/";
}

function deleteCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

const styleSwitcher = document.querySelectorAll(".style-switcher");

if (styleSwitcher.length) {
  // Toggle Pallets Style
  const switcherWrap = document.querySelector(".style-switcher");
  const switcherBtn = document.querySelector(".style-switcher-open");

  switcherBtn.addEventListener("click", ($e) => {
    switcherWrap.classList.toggle("active");
    $e.preventDefault();
  });

  // Reset Cookie & Set Default Value
  const resetBtn = document.querySelector(".style-switcher-buttons .reset");
  resetBtn.addEventListener("click", () => {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i += 1) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      deleteCookie(name);
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    window.location.reload();
  });

  const root = document.documentElement;
  const body = document.querySelector("body");
  const switcherBtnSubmit = document.querySelector(
    ".style-switcher-buttons .submit"
  );
  const switcherInput = document.querySelectorAll(
    ".style-switcher form input[type=text]"
  );
  const switcherInputColor = document.querySelectorAll(
    ".style-switcher form input[type=color]"
  );

  const allcookies = document.cookie;
  const switcherFormTextArea = document.querySelector(
    ".style-switcher form textarea"
  );
  const switcherFormTextAreaName = switcherFormTextArea.getAttribute("name");

  // Default Font Selector
  const fontSelect = document.querySelector(".font-selector select");
  const fontCheck = body.style.setProperty(
    "--font-family-primary",
    document.querySelector(".font-family__input").value
  );
  const fontList = fontSelect.options[fontSelect.selectedIndex].value;
  if (fontList == 0) {
    body.style.setProperty(
      "--font-family-primary",
      document.querySelector(".font-family__input").value
    );
    document.querySelector(".font-customised").classList.add("d-none");
  } else if (fontList == 1) {
    body.style.setProperty("--font-family-primary", '"Work Sans", sans-serif');
    document.querySelector(".font-customised").classList.add("d-none");
  } else if (fontList == 2) {
    body.style.setProperty("--font-family-primary", '"Open Sans", sans-serif');
    document.querySelector(".font-customised").classList.add("d-none");
  } else if (fontList == 3) {
    body.style.setProperty("--font-family-primary", '"montserrat", sans-serif');
    document.querySelector(".font-customised").classList.add("d-none");
  } else if (fontList == 4) {
    document.querySelector(".font-customised").classList.remove("d-none");
    body.style.setProperty(
      "--font-family-primary",
      document.querySelector(".font-family__input").value
    );
  }
  if (fontCheck == undefined) {
    fontSelect.options[0].setAttribute("disabled", "disabled");
    fontSelect.options[1].setAttribute("selected", "selected");
  }
  fontSelect.addEventListener("change", () => {
    const fontOption = fontSelect.options[fontSelect.selectedIndex].value;
    if (fontOption == 0) {
      body.style.setProperty(
        "--font-family-primary",
        document.querySelector(".font-family__input").value
      );
      document.querySelector(".font-customised").classList.add("d-none");
    } else if (fontOption == 1) {
      body.style.setProperty(
        "--font-family-primary",
        '"Work Sans", sans-serif'
      );
      document.querySelector(".font-customised").classList.add("d-none");
    } else if (fontOption == 2) {
      body.style.setProperty(
        "--font-family-primary",
        '"Open Sans", sans-serif'
      );
      document.querySelector(".font-customised").classList.add("d-none");
    } else if (fontOption == 3) {
      body.style.setProperty(
        "--font-family-primary",
        '"montserrat", sans-serif'
      );
      document.querySelector(".font-customised").classList.add("d-none");
    } else if (fontOption == 4) {
      document.querySelector(".font-customised").classList.remove("d-none");
      body.style.setProperty(
        "--font-family-primary",
        document.querySelector(".font-family__input").value
      );
    }
  });

  if (allcookies.length !== 0) {
    const formCookise = getCookie("tx_style");

    const newFormCookie = formCookise.filter((c) => {
      return c;
    });

    for (let j = 0; j < newFormCookie.length; j += 1) {
      const gsplit = newFormCookie[j].split("]=");
      if (switcherFormTextAreaName === gsplit[0] + "]") {
        switcherFormTextArea.value = gsplit[1];
        switcherFormTextArea.setAttribute("value", gsplit[1]);
        switcherFormTextArea.innerHTML = gsplit[1];
      } else if ("tx_style[layout]" === gsplit[0] + "]") {
        if (gsplit[1] == "boxed") {
          document.querySelector("body").classList.add("boxed");
          document.querySelector(".layout--boxed").classList.add("active");
          document.querySelector(".layout--wide").classList.remove("active");
          document.querySelector(".pattern-wrapper").classList.remove("d-none");
        } else {
          document.querySelector("body").classList.remove("boxed");
          document.querySelector(".layout--boxed").classList.remove("active");
          document.querySelector(".layout--wide").classList.add("active");
          document.querySelector(".pattern-wrapper").classList.add("d-none");
        }
      } else if ("tx_style[pattern]" === gsplit[0] + "]") {
        document.querySelector("body").style.backgroundImage =
          "url('https://demo.t3planet.com/t3-bootstrap/fileadmin/ns_theme_bootstrap/Images/patterns/" +
          gsplit[1] +
          ".png')";
      } else if ("tx_style[background]" === gsplit[0] + "]") {
        if (gsplit[1] == "dark") {
          document.querySelector("body").classList.add("dark");
          document.querySelector(".bg-color-light").classList.remove("active");
          document.querySelector(".bg-color-dark").classList.add("active");
        } else {
          document.querySelector("body").classList.remove("dark");
          document.querySelector(".bg-color-light").classList.add("active");
          document.querySelector(".bg-color-dark").classList.remove("active");
        }
      } else if ("tx_style[font-family-select]" === gsplit[0] + "]") {
        const fontCookie = document.querySelector(".main-font-family-select");
        fontCookie.options[gsplit[1]].setAttribute("selected", "selected");
        if (gsplit[1] === "4") {
          document.querySelector(".font-customised").classList.remove("d-none");
        }
      } else if ("tx_style[pre-loader]" === gsplit[0] + "]") {
        body.classList.add("loading-overlay-showing");
        const loaderCookie = document.querySelector(".pre-loader select");
        let loaderType = loaderCookie.options[gsplit[1]].value;
        renderLoader(loaderType);
        loaderCookie.options[gsplit[1]].setAttribute("selected", "selected");
      }
    }
  }

  for (let i = 0; i < switcherInput.length; i += 1) {
    const name = switcherInput[i].getAttribute("name");

    if (allcookies.length !== 0) {
      const formCookise = getCookie("tx_style");
      const newFormCookie = formCookise.filter((c) => {
        return c;
      });

      for (let j = 0; j < newFormCookie.length; j += 1) {
        const gsplit = newFormCookie[j].split("=");

        if (name === gsplit[0]) {
          switcherInput[i].value === gsplit[1];
          switcherInput[i].setAttribute("value", gsplit[1]);
          if (switcherInputColor[i]) {
            switcherInputColor[i].setAttribute("value", gsplit[1]);
          }
        }
      }
    }
  }

  // Form Final Submit
  switcherBtnSubmit.addEventListener("click", ($e) => {
    // TextArea
    const switcherFormTextAreaVal = switcherFormTextArea.getAttribute("value");
    Setcookie(switcherFormTextAreaName, switcherFormTextAreaVal);

    // Input Text Color/Font
    const switcherForm = document.querySelectorAll(
      ".style-switcher form input[type=text]"
    );
    for (let i = 0; i < switcherForm.length; i += 1) {
      const inputName = switcherForm[i].getAttribute("name");
      const inputValue = switcherForm[i].getAttribute("value");
      Setcookie(inputName, inputValue);
    }

    // Layout Selection
    const layoutList = document.querySelectorAll(".style-switcher .layout a");
    for (let i = 0; i < layoutList.length; i += 1) {
      const btnName = "tx_style[layout]";
      if (layoutList[i].classList.contains("active")) {
        const btnValue = layoutList[i].getAttribute("data-val");
        Setcookie(btnName, btnValue);
      }
    }

    // Background Pattern
    const patternList = document.querySelectorAll(".layout-patterns .pattern");
    for (let i = 0; i < patternList.length; i += 1) {
      const patternName = "tx_style[pattern]";
      if (patternList[i].classList.contains("active-pattern")) {
        const patternValue = patternList[i].getAttribute("data-pattern");
        Setcookie(patternName, patternValue);
      }
    }

    // Background Color
    const bgList = document.querySelectorAll(".site-bg a");
    for (let i = 0; i < bgList.length; i += 1) {
      const bgName = "tx_style[background]";
      if (bgList[i].classList.contains("active")) {
        const bgValue = bgList[i].getAttribute("data-bg");
        Setcookie(bgName, bgValue);
      }
    }

    // Font Selector Active
    const fontSelector = document.querySelector(".main-font-family-select");
    const fontOption = fontSelector.options[fontSelector.selectedIndex].value;

    if (fontOption == 0) {
      Setcookie(
        "tx_style[font-family-name]",
        document.querySelector(".font-family__input").value
      );
    } else if (fontOption == 1) {
      body.style.setProperty(
        "--font-family-primary",
        '"Work Sans", sans-serif'
      );
      Setcookie("tx_style[font-family-name]", '"Work Sans", sans-serif');
    } else if (fontOption == 2) {
      body.style.setProperty(
        "--font-family-primary",
        '"Open Sans", sans-serif'
      );
      Setcookie("tx_style[font-family-name]", '"Open Sans", sans-serif');
    } else if (fontOption == 3) {
      body.style.setProperty(
        "--font-family-primary",
        '"montserrat", sans-serif'
      );
      Setcookie("tx_style[font-family-name]", '"montserrat", sans-serif');
    } else if (fontOption == 4) {
      document.querySelector(".font-customised").classList.remove("d-none");
      Setcookie(
        "tx_style[font-family-name]",
        document.querySelector(".font-family__input").value
      );
    }
    Setcookie("tx_style[font-family-select]", fontOption);

    // Pre Loader Store Cookie
    const loaderSelect = document.querySelector(".pre-loader select");
    const loaderListIndex =
      loaderSelect.options[loaderSelect.selectedIndex].index;
    Setcookie("tx_style[pre-loader]", loaderListIndex);

    window.location.reload();
  });

  // Pre Loader Selection code
  const loaderSelect = document.querySelector(".pre-loader select");

  if (body.classList.contains("loading-overlay-showing")) {
    setTimeout(() => {
      body.classList.remove("loading-overlay-showing");
    }, 3000);
  }

  function renderLoader(loaderList) {
    switch (loaderList) {
      case "none":
        s = [].join("");
        break;
      case "default":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<div class="bounce1"></div>\n',
          '\t\t<div class="bounce2"></div>\n',
          '\t\t<div class="bounce3"></div>\n',
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      case "cubes":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<div class="cssload-thecube">\n',
          '\t\t\t<div class="cssload-cube cssload-c1"></div>\n',
          '\t\t\t<div class="cssload-cube cssload-c2"></div>\n',
          '\t\t\t<div class="cssload-cube cssload-c4"></div>\n',
          '\t\t\t<div class="cssload-cube cssload-c3"></div>\n',
          "\t\t</div>\n",
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      case "cubeProgress":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<span class="cssload-cube-progress">\n',
          '\t\t\t<span class="cssload-cube-progress-inner"></span>\n',
          "\t\t</span>\n",
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      case "floatRings":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<div class="cssload-float-rings-loader">\n',
          '\t\t\t<div class="cssload-float-rings-inner cssload-one"></div>\n',
          '\t\t\t<div class="cssload-float-rings-inner cssload-two"></div>\n',
          '\t\t\t<div class="cssload-float-rings-inner cssload-three"></div>\n',
          "\t\t</div>\n",
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      case "floatBars":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<div class="cssload-float-bars-container">\n',
          '\t\t\t<ul class="cssload-float-bars-flex-container">\n',
          "\t\t\t\t<li>\n",
          '\t\t\t\t\t<span class="cssload-float-bars-loading"></span>\n',
          "\t\t\t\t</li>\n",
          "\t\t\t</ul>\n",
          "\t\t</div>\n",
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      case "speedingWheel":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<div class="cssload-speeding-wheel-container">\n',
          '\t\t\t<div class="cssload-speeding-wheel"></div>\n',
          "\t\t</div>\n",
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      case "zenith":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<div class="cssload-zenith-container">\n',
          '\t\t\t<div class="cssload-zenith"></div>\n',
          "\t\t</div>\n",
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      case "spinningSquare":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<div class="cssload-spinning-square-loading"></div>\n',
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      case "pulse":
        s = [
          '<div class="loading-overlay">\n',
          '\t<div class="bounce-loader">\n',
          '\t\t<div class="wrapper-pulse">\n',
          '\t\t\t<div class="cssload-pulse-loader"></div>\n',
          "\t\t</div>\n",
          "\t</div>\n",
          "</div>",
        ].join("");
        break;
      default:
        s = [].join("");
    }
    selectBodyWrapper.insertAdjacentHTML("beforebegin", s);
    if (body.classList.contains("loading-overlay-showing")) {
      setTimeout(() => {
        body.classList.remove("loading-overlay-showing");
      }, 3000);
    }
  }

  loaderSelect.addEventListener("change", () => {
    const loaderWrapper = document.querySelectorAll(".loading-overlay");
    if (loaderWrapper.length > 0) {
      loaderWrapper[0].parentNode.removeChild(loaderWrapper[0]);
    }

    const loaderList = loaderSelect.options[loaderSelect.selectedIndex].value;
    body.classList.add("loading-overlay-showing");
    renderLoader(loaderList);
  });

  // Layout switcher Code
  const layoutWide = document.querySelector(".layout--wide");
  const layoutBox = document.querySelector(".layout--boxed");
  const patternBox = document.querySelector(".pattern-wrapper");
  const htmlSelector = document.querySelector("body");

  layoutWide.addEventListener("click", () => {
    layoutWide.classList.add("active");
    layoutBox.classList.remove("active");
    htmlSelector.classList.remove("boxed");
    patternBox.classList.add("d-none");
  });

  layoutBox.addEventListener("click", () => {
    layoutWide.classList.remove("active");
    layoutBox.classList.add("active");
    htmlSelector.classList.add("boxed");
    patternBox.classList.remove("d-none");
  });

  //Pattern Update
  const patternItems = document.querySelectorAll(".pattern-wrapper .pattern");
  patternItems.forEach(($e) => {
    $e.addEventListener("click", () => {
      for (let i = 0; i < patternItems.length; i += 1) {
        patternItems[i].classList.remove("active-pattern");
      }
      $e.classList.add("active-pattern");
      const activeBG = $e.getAttribute("data-pattern");
      document.querySelector("body").style.backgroundImage =
        "url('https://demo.t3planet.com/t3-bootstrap/fileadmin/ns_theme_bootstrap/Images/patterns/" +
        activeBG +
        ".png')";
    });
  });

  // Background Color Update
  const colorLight = document.querySelector(".bg-color-light");
  const colorDark = document.querySelector(".bg-color-dark");

  colorLight.addEventListener("click", () => {
    colorLight.classList.add("active");
    colorDark.classList.remove("active");
    htmlSelector.classList.remove("dark");

    const textdarkInput = document.querySelector(".text-color-input");
    textdarkInput.setAttribute("value", "#122241");
    body.style.setProperty("--text-color", "#122241");
    document
      .querySelector(".text-color-select")
      .setAttribute("value", "#122241");
  });

  colorDark.addEventListener("click", () => {
    colorLight.classList.remove("active");
    colorDark.classList.add("active");
    htmlSelector.classList.add("dark");

    const textdarkInput = document.querySelector(".text-color-input");
    textdarkInput.setAttribute("value", "#ffffff");
    body.style.setProperty("--text-color", "#fff");
    document
      .querySelector(".text-color-select")
      .setAttribute("value", "#ffffff");
  });

  function inputFont() {
    let primaryFont;
    primaryFont = document.querySelector(".font-family__input");
    primaryFont.addEventListener("keyup", updateFont, false);
    primaryFont.select();
    updateFont();
  }

  function primaryColor() {
    let primaryInput;
    primaryInput = document.querySelector(".primary-color-input");
    primaryInput.addEventListener("keyup", updatePrimary, false);
    primaryInput.select();

    let primarySelect;
    primarySelect = document.querySelector(".primary-color-select");
    primarySelect.addEventListener("input", updatePrimary, false);
    primarySelect.select();

    updatePrimary();
  }

  function secondaryColor() {
    let secondaryInput;
    secondaryInput = document.querySelector(".secondary-color-input");
    secondaryInput.addEventListener("keyup", updateSecondary, false);
    secondaryInput.select();

    let secondarySelect;
    secondarySelect = document.querySelector(".secondary-color-select");
    secondarySelect.addEventListener("input", updateSecondary, false);
    secondarySelect.select();

    updateSecondary();
  }

  function textColor() {
    let textInput;
    textInput = document.querySelector(".text-color-input");
    textInput.addEventListener("keyup", updateText, false);
    textInput.select();

    let textSelect;
    textSelect = document.querySelector(".text-color-select");
    textSelect.addEventListener("input", updateText, false);
    textSelect.select();

    updateText();
  }

  function secondarylightColor() {
    let secondarylightInput;
    secondarylightInput = document.querySelector(
      ".secondary-light-color-input"
    );
    secondarylightInput.addEventListener("keyup", updateSecondarylight, false);
    secondarylightInput.select();

    let secondarylightSelect;
    secondarylightSelect = document.querySelector(
      ".secondary-light-color-select"
    );
    secondarylightSelect.addEventListener("input", updateSecondarylight, false);
    secondarylightSelect.select();

    updateSecondarylight();
  }

  function darkColor() {
    let darkInput;
    darkInput = document.querySelector(".dark-color-input");
    darkInput.addEventListener("keyup", updateDark, false);
    darkInput.select();

    let darkSelect;
    darkSelect = document.querySelector(".dark-color-select");
    darkSelect.addEventListener("input", updateDark, false);
    darkSelect.select();

    updateDark();
  }

  function updatePrimary(event) {
    if (body) {
      if (event) {
        body.style.setProperty("--primary-color", event.target.value);
      } else {
        setTimeout(() => {
          body.style.setProperty(
            "--primary-color",
            document.querySelector(".primary-color-input").value
          );
        }, 300);
      }
    }
  }

  function updateSecondary(event) {
    if (body) {
      if (event) {
        body.style.setProperty("--secondary-color", event.target.value);
      } else {
        body.style.setProperty(
          "--secondary-color",
          document.querySelector(".secondary-color-input").value
        );
      }
    }
  }

  function updateText(event) {
    if (body) {
      if (event) {
        body.style.setProperty("--text-color", event.target.value);
      } else {
        body.style.setProperty(
          "--text-color",
          document.querySelector(".text-color-input").value
        );
      }
    }
  }

  function updateSecondarylight(event) {
    if (body) {
      if (event) {
        body.style.setProperty("--secondary-color-light", event.target.value);
      } else {
        body.style.setProperty(
          "--secondary-color-light",
          document.querySelector(".secondary-light-color-input").value
        );
      }
    }
  }

  function updateFont(event) {
    if (body) {
      if (event) {
        body.style.setProperty("--font-family-primary", event.target.value);
      } else {
        body.style.setProperty(
          "--font-family-primary",
          document.querySelector(".font-family__input").value
        );
      }
    }
  }

  // Color Change Code
  window.addEventListener("load", primaryColor, false);
  window.addEventListener("load", secondaryColor, false);
  window.addEventListener("load", textColor, false);
  window.addEventListener("load", secondarylightColor, false);
  window.addEventListener("load", inputFont, false);

  // Color Picker Update
  document
    .querySelector(".primary-color-select")
    .addEventListener("change", () => {
      document.querySelector(".primary-color-input").value =
        document.querySelector(".primary-color-select").value;
      document
        .querySelector(".primary-color-input")
        .setAttribute(
          "value",
          document.querySelector(".primary-color-select").value
        );
    });

  document
    .querySelector(".secondary-color-select")
    .addEventListener("change", () => {
      document.querySelector(".secondary-color-input").value =
        document.querySelector(".secondary-color-select").value;
      document
        .querySelector(".secondary-color-input")
        .setAttribute(
          "value",
          document.querySelector(".secondary-color-select").value
        );
    });

  document
    .querySelector(".text-color-select")
    .addEventListener("change", () => {
      document.querySelector(".text-color-input").value =
        document.querySelector(".text-color-select").value;
      document
        .querySelector(".text-color-input")
        .setAttribute(
          "value",
          document.querySelector(".text-color-select").value
        );
    });

  document
    .querySelector(".secondary-light-color-select")
    .addEventListener("change", () => {
      document.querySelector(".secondary-light-color-input").value =
        document.querySelector(".secondary-light-color-select").value;
      document
        .querySelector(".secondary-light-color-input")
        .setAttribute(
          "value",
          document.querySelector(".secondary-light-color-select").value
        );
    });

  // Input text Color Code Update
  document
    .querySelector(".primary-color-input")
    .addEventListener("keyup", () => {
      document.querySelector(".primary-color-select").value =
        document.querySelector(".primary-color-input").value;
      document
        .querySelector(".primary-color-input")
        .setAttribute(
          "value",
          document.querySelector(".primary-color-input").value
        );
    });

  document
    .querySelector(".secondary-color-input")
    .addEventListener("keyup", () => {
      document.querySelector(".secondary-color-select").value =
        document.querySelector(".secondary-color-input").value;
      document
        .querySelector(".secondary-color-input")
        .setAttribute(
          "value",
          document.querySelector(".secondary-color-input").value
        );
    });

  document.querySelector(".text-color-input").addEventListener("keyup", () => {
    document.querySelector(".text-color-select").value =
      document.querySelector(".text-color-input").value;
    document
      .querySelector(".text-color-input")
      .setAttribute("value", document.querySelector(".text-color-input").value);
  });

  document
    .querySelector(".secondary-light-color-input")
    .addEventListener("keyup", () => {
      document.querySelector(".secondary-light-color-select").value =
        document.querySelector(".secondary-light-color-input").value;
      document
        .querySelector(".secondary-light-color-input")
        .setAttribute(
          "value",
          document.querySelector(".secondary-light-color-input").value
        );
    });

  document
    .querySelector(".font-family__input")
    .addEventListener("keyup", () => {
      document
        .querySelector(".font-family__input")
        .setAttribute(
          "value",
          document.querySelector(".font-family__input").value
        );
    });

  document
    .querySelector(".font-family-wrapper")
    .addEventListener("keyup", () => {
      document
        .querySelector(".font-family-wrapper")
        .setAttribute(
          "value",
          document.querySelector(".font-family-wrapper").value
        );
    });
}

/* End Color Pallate Code */
